module.exports = __webpack_public_path__ + "img/logo_blue.d383dba0.svg";